export const buildTime = '2026-10-20 13:37:22 UTC';
